import { IDropdownOption } from "@fluentui/react";

export const YesNoOptionGridDropdownOptions: string[] = ["","Yes", "No"];

export const YesNoOptionDropdownOptions: IDropdownOption[] = [
    { key: "", text: "Select" },
    { key: "true", text: "Yes" },
    { key: "false", text: "No" },
];